import React, {useCallback, useEffect, useRef, useState} from 'react';
import CommonSection from "../../components/Layout/CommonSection";
import {Link} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {getNews} from "../../redux/actions/actions";
import TabsRender from "../../components/TabsRender";
import Webcam from "react-webcam";
import InputMask from "react-input-mask";
import {toast} from "react-toastify";
import axios from "axios";
import SuccessModal from "../../components/modal/SuccessModal";
import PolicyModal from "../../components/modal/PolicyModal";
import IMAGE from "../../assets/ict.png"

const tabs = [
  {
    title: 'Kamera',
    active: true
  },
  {
    title: "Sur'at yuklash",
    active: false
  }
]

const Register = () => {
  const dispatch = useDispatch();
  const {news} = useSelector((state) => state.news);
  const {location} = useSelector((state) => state.location);
  const {t} = useTranslation();

  const webRef = useRef(null)

  const [openTab, setOpenTab] = useState(tabs.findIndex(tab => tab.active));

  const [loader, setLoader] = useState(false)

  const [image, setImage] = useState('')
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [position, setPosition] = useState("");

  const [devices, setDevices] = useState([])

  const [fileName, setFileName] = useState(null)

  const [modal, setModal] = useState(false)

  const [policy, setPolicy] = useState(false)
  const [modalPolicy, setModalPolicy] = useState(false)

  const [serviceCheck, setServiceCheck] = useState(false)

  const handleDevices = useCallback((mediaDevices) => {
    setDevices(mediaDevices.filter(({kind}) => kind === 'videoinput'))
  }, [setDevices])

  useEffect(() => {
    dispatch(getNews({type}));
  }, [dispatch]);

  useEffect(() => {
    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      navigator.mediaDevices.enumerateDevices().then(handleDevices);
    }
  }, [handleDevices]);

  const type = "yangiliklar?last_count=6";

  const capture = useCallback(
    () => {
      const imageSrc = webRef.current.getScreenshot();
      setImage(imageSrc)
      setFileName(null)
    },
    [webRef]
  );

  function getBase64(file) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setImage(reader.result)
    };
    reader.onerror = function (error) {
      toast.error(error)
      console.log('Error: ', error);
    };

  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name) {
      toast.error("Ismingiz yoki tashkilot nomini kiritmadingiz!");
    } else if (!phone_number) {
      toast.error("Telefon raqamingizni kiritmadingiz!");
    } else if (!image) {
      toast.error(openTab === 0 ? "Sur'atga olmadingiz!" : "Sur'at yuklamadingiz");
    } else if (!email) {
      toast.error("Email pochtangizni kiritmadingiz!");
    } else if (!position) {
      toast.error("Familiyangiz kiritmadingiz!");
    } else {
      setLoader(true)
      try {
        await axios.post(`${'https://back.unicon.uz/api'}/faceid/faceid-data`, {
          full_name: name.toUpperCase(),
          phone_number,
          surname: position,
          email,
          file_base64: image
        }).then((res) => {
          if (res.status === 201) {
            setLoader(false)
            setModal(true)
            setName("");
            setEmail("");
            setPhoneNumber("");
            setPosition("");
            setImage("")
            setFileName(null)
          }
        })
      } catch (e) {
        setLoader(false)
        if (e?.response?.status === 400) {
          toast.error(e?.response?.data?.non_field_errors[0])
        } else {
          toast.error("Xatolik")
        }
      }
    }
  };

  const render = (step) => {
    switch (step) {
      case 0:
        return (
          <>
            <div className="box flex justify-center">
              <div className="content flex justify-between mt-5 md:flex-wrap-reverse md:gap-4">
                <div
                  className="card left w-[48%] md:w-full border border-[#abb8c3]"
                >
                  <form
                    onSubmit={handleSubmit}
                    className="w-full md:w-full flex flex-wrap justify-between gap-5 py-5 px-8"
                  >
                    <label
                      htmlFor="name"
                      className="flex flex-col gap-2 w-full lg:w-full md:w-full xs:w-full"
                    >
                      <span className="text-grey">{t("name")} *</span>
                      <input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        type="text"
                        id="name"
                        className="border border-logo rounded-lg py-2 px-4"
                      />
                    </label>
                    <label htmlFor="email" className="flex flex-col gap-2 w-full">
                      <span className="text-grey">
                        {location === 'uz' ? 'Familiyangiz *' : location === 'ru' ? 'Фамилия *' : 'SurName *'}
                      </span>
                      <input
                        value={position}
                        onChange={(e) => setPosition(e.target.value)}
                        type="text"
                        id="email"
                        className="border border-logo rounded-lg py-2 px-4"
                      />
                    </label>
                    <label
                      htmlFor="phone"
                      className="flex flex-col gap-2 w-full lg:w-full md:w-full xs:w-full"
                    >
                      <span className="text-grey">{t("phone")} *</span>
                      <InputMask
                        mask={"+999 (99) 999 99 99"}
                        value={phone_number}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        className="border border-logo rounded-lg py-2 px-4"
                        type="tel"
                        name="phone_number"
                      />
                    </label>

                    <label htmlFor="email" className="flex flex-col gap-2 w-full">
                      <span className="text-grey">{t("email")} *</span>
                      <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="text"
                        id="email"
                        className="border border-logo rounded-lg py-2 px-4"
                      />
                    </label>
                    <div className="flex items-center gap-2">
                      <input
                        checked={policy}
                        value={policy}
                        onChange={(e) => setPolicy(e.target.checked)}
                        type="checkbox"
                        className="border border-logo rounded-lg py-2 px-4"
                      />
                      <label htmlFor="policy" className="cursor-pointer" onClick={() => setModalPolicy(true)}>
                        {location === 'uz' ?
                          <h1>
                            Shaxsiy ma'lumotlarimni uzatilishiga va tegishli axborot tizimlarida qayta ishlanishiga
                            roziman. *
                          </h1> :
                          location === 'ru' ?
                            <h1>
                              Я согласен с тем, что мои персональные данные будут передаваться и обрабатываются в
                              соответствующих информационных системах. *
                            </h1> :
                            <h1>
                              I agree that my personal data will be transferred and processed in the appropriate
                              information systems. *
                            </h1>
                        }
                      </label>
                    </div>

                    <div className="flex items-center gap-2">
                      <input
                        checked={serviceCheck}
                        value={serviceCheck}
                        onChange={(e) => setServiceCheck(e.target.checked)}
                        type="checkbox"
                        id="serviceCheck"
                        className="border border-logo rounded-lg py-2 px-4"
                      />
                      <label htmlFor="serviceCheck">
                        {location === 'uz' ?
                          <h1>
                            Kiritilgan ma'lumotlarim <span className="font-bold">UNICON.UZ</span> tomonidan qayta aloqa
                            qilish va xabarlarni elektron yuborish orqali xizmatlarini taklif qilish uchun
                            ishlatilishiga roziman *
                          </h1> :
                          location === 'ru' ?
                            <h1>
                              Я согласен, что мои введенные данные будут использоваться <span className="font-bold"
                            >UNICON.UZ</span> для обратной связи и отправки сообщений в электронном виде для предложения
                              своих услуг *
                            </h1> :
                            <h1>
                              I agree that my entered data will be used by <span className="font-bold"
                            >UNICON.UZ</span> for feedback and sending messages electronically to offer their services.
                              *
                            </h1>
                        }
                      </label>
                    </div>
                    <button
                      className="disabled:opacity-25 ml-auto px-4 py-2 mt-3 rounded-[4px] bg-[#0E0E4B] text-white xs:px-2 xs:py-1 justify-center duration-200 opacity-70 hover:opacity-100"
                      // className="bg-logo text-white px-4 py-2 hover:bg-hover duration-300 ml-auto"
                      disabled={!policy || !serviceCheck}
                    >
                      {loader ? 'Loading...' : t("send")}
                    </button>
                  </form>
                </div>
                <div className="flex flex-col gap-2 justify-between right w-1/2 md:w-full">
                  {image === '' ? (
                    <>
                      {devices.length > 0 && devices?.map((device, key) => (
                        <div key={key}>
                          <Webcam
                            ref={webRef}
                            audio={false}
                            videoConstraints={{deviceId: device?.deviceId, facingMode: 'user'}}
                            mirrored={true}
                            className="w-full"
                          />
                        </div>
                      ))}
                      {devices.length > 0 && (
                        <button onClick={capture} className="text-4xl xs:text-xl border rounded-full w-[8%] m-auto">
                          <i className="ri-camera-line"></i>
                        </button>
                      )}
                      {devices.length === 0 && (
                        <div
                          className="card w-full border border-[#abb8c3] h-full rounded flex items-center justify-center"
                        >
                          {location === 'uz' ? 'Qurilmangizda kamera topilmadi' : location === 'ru' ? 'На вашем устройстве не найдена камера' : 'No camera found on your device'}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <img src={image} alt=""/>
                      <button onClick={() => setImage('')}
                              className="text-4xl xs:text-xl border rounded-full w-[8%] m-auto"
                      >
                        X
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        )
      case 1:
        return (
          <>
            <div className="box flex justify-center">
              <div className="content flex justify-between mt-5 md:flex-wrap-reverse md:gap-4">
                <div
                  className="card left w-[48%] md:w-full border border-[#abb8c3]"
                >
                  <form
                    onSubmit={handleSubmit}
                    className="w-full md:w-full flex flex-wrap justify-between gap-5 py-5 px-8"
                  >
                    <label
                      htmlFor="name"
                      className="flex flex-col gap-2 w-full lg:w-full md:w-full xs:w-full"
                    >
                      <span className="text-grey">{t("name")} *</span>
                      <input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        type="text"
                        id="name"
                        className="border border-logo rounded-lg py-2 px-4"
                      />
                    </label>
                    <label htmlFor="email" className="flex flex-col gap-2 w-full">
                      <span className="text-grey">
                        {location === 'uz' ? 'Familiyangiz *' : location === 'ru' ? 'Фамилия *' : 'SurName *'}
                      </span>
                      <input
                        value={position}
                        onChange={(e) => setPosition(e.target.value)}
                        type="text"
                        id="email"
                        className="border border-logo rounded-lg py-2 px-4"
                      />
                    </label>
                    <label
                      htmlFor="phone"
                      className="flex flex-col gap-2 w-full lg:w-full md:w-full xs:w-full"
                    >
                      <span className="text-grey">{t("phone")} *</span>
                      <InputMask
                        mask={"+999 (99) 999 99 99"}
                        value={phone_number}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        className="border border-logo rounded-lg py-2 px-4"
                        type="tel"
                        name="phone_number"
                      />
                    </label>

                    <label htmlFor="email" className="flex flex-col gap-2 w-full">
                      <span className="text-grey">{t("email")} *</span>
                      <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="text"
                        id="email"
                        className="border border-logo rounded-lg py-2 px-4"
                      />
                    </label>

                    <div className='flex flex-col items-start'>
                      <label className='mb-2' htmlFor="file1"
                      >{location === 'uz' ? 'Rasm yuklash' : location === 'ru' ? "Загрузить фото" : "Upload photo"} (png/jpg/jpeg)
                        *</label>
                      <label className="custom-file-upload">
                        <input id="max_id" type="hidden" name="MAX_FILE_SIZE" value="5245880"/>
                        <input
                          onChange={(e) => {
                            setFileName(e.target.files[0].name)
                            getBase64(e.target.files[0])
                          }}
                          accept='.png, .jpg, .jpeg'
                          type="file"
                        />
                        {location === 'uz' ? 'Yuklash' : location === 'ru' ? "Загрузить" : "Upload"}
                      </label>
                      {fileName}
                    </div>
                    <div className="flex items-center gap-2">
                      <input
                        checked={policy}
                        value={policy}
                        onChange={(e) => setPolicy(e.target.checked)}
                        type="checkbox"
                        className="border border-logo rounded-lg py-2 px-4"
                      />
                      <label htmlFor="policy" className="cursor-pointer" onClick={() => setModalPolicy(true)}>
                        {location === 'uz' ?
                          <h1>
                            Shaxsiy ma'lumotlarimni uzatilishiga va tegishli axborot tizimlarida qayta ishlanishiga
                            roziman. *
                          </h1> :
                          location === 'ru' ?
                            <h1>
                              Я согласен с тем, что мои персональные данные будут передаваться и обрабатываются в
                              соответствующих информационных системах. *
                            </h1> :
                            <h1>
                              I agree that my personal data will be transferred and processed in the appropriate
                              information systems. *
                            </h1>
                        }
                      </label>
                    </div>
                    <div className="flex items-center gap-2">
                      <input
                        checked={serviceCheck}
                        value={serviceCheck}
                        onChange={(e) => setServiceCheck(e.target.checked)}
                        type="checkbox"
                        id="serviceCheck"
                        className="border border-logo rounded-lg py-2 px-4"
                      />
                      <label htmlFor="serviceCheck">
                        {location === 'uz' ?
                          <h1>
                            Kiritilgan ma'lumotlarim <span className="font-bold">UNICON.UZ</span> tomonidan qayta aloqa
                            qilish va xabarlarni elektron yuborish orqali xizmatlarini taklif qilish uchun
                            ishlatilishiga roziman *
                          </h1> :
                          location === 'ru' ?
                            <h1>
                              Я согласен, что мои введенные данные будут использоваться <span className="font-bold"
                            >UNICON.UZ</span> для обратной связи и отправки сообщений в электронном виде для предложения
                              своих услуг *
                            </h1> :
                            <h1>
                              I agree that my entered data will be used by <span className="font-bold"
                            >UNICON.UZ</span> for feedback and sending messages electronically to offer their services.
                              *
                            </h1>
                        }
                      </label>
                    </div>
                    <button
                      className="disabled:opacity-25 ml-auto px-4 py-2 mt-3 rounded-[4px] bg-[#0E0E4B] text-white xs:px-2 xs:py-1 justify-center duration-200 opacity-70 hover:opacity-100"
                      // className="bg-logo text-white px-4 py-2 hover:bg-hover duration-300 ml-auto"
                      disabled={!policy || !serviceCheck}
                    >
                      {loader ? 'Loading...' : t("send")}
                    </button>
                  </form>
                </div>
                <div className="flex flex-col gap-2 justify-between right w-1/2 md:w-full">
                  {image === '' ? (
                    <>
                      <div className="w-full h-full border border-[#abb8c3]"></div>
                    </>
                  ) : (
                    <>
                      <img src={image} alt="" className="w-full h-[394px] object-contain"/>
                      <button
                        onClick={() => {
                          setImage('')
                          setFileName(null)
                        }}
                        className="text-4xl xs:text-xl border rounded-full w-[8%] m-auto"
                      >
                        X
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        )
      default:
        return null
    }
  }

  return (
    <>
      <div className="relative w-full">
        <CommonSection
          title={location === 'uz' ? "Ro'yxatdan o'tish" : location === 'ru' ? "Регистрация" : "Register"}
          // breadCrumb={
          //   location === "uz" ? singleNew.title_uz : singleNew.title_ru
          // }
        />

        <div className="container flex mx-auto">
          <div className="w-1/4 pr-5 pt-5 lg:hidden">
            <div>
              {news &&
                news?.result?.map((item, idx) => (
                  <Link
                    key={idx}
                    className="flex min-h-[90px] pb-5 border-b border-[#ccc] mb-5"
                    to={`/news/${item.id}`}
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    {item?.files[0]?.is_video ? (
                      <iframe
                        className="object-cover block h-[70px]"
                        title="video"
                        src={`${item?.files[0]?.video_url}`}
                        width={"100%"}
                        height={"100%"}
                        style={{
                          height: "70px",
                          width: "70px",
                          objectFit: "cover",
                        }}
                        frameBorder={0}
                        allowFullScreen={true}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      />
                    ) : (
                      <img
                        className="object-cover block h-[70px]"
                        width={"70"}
                        height={"70"}
                        src={`${item?.files[0]?.file}`}
                        alt="rasm"
                      />
                    )}
                    <div className="pl-4">
                      <p className="text-logo hover:text-hover text-xs uppercase mb-2">
                        {location === "uz"
                          ? item?.title_uz?.substring(0, 70)
                          : location === 'ru' ? item?.title_ru?.substring(0, 70)
                            : item?.title_en?.substring(0, 70)}
                      </p>
                      <div
                        className="text-logo-secondary hover:text-hover text-xs"
                        dangerouslySetInnerHTML={{
                          __html:
                            location === "uz"
                              ? item?.content_uz?.substring(3, 70)
                              : location === 'ru' ? item?.content_ru?.substring(3, 70)
                                : item?.content_en?.substring(3, 70),
                        }}
                      />
                    </div>
                  </Link>
                ))}
            </div>
          </div>
          <div className="w-3/4 lg:w-full box py-5">
            <div className="flex justify-center m-1 md:mx-4 md:mb-1 p-2 md:px-4 md:py-4 bg-white rounded">
              <TabsRender
                tabs={tabs}
                color={'#0E0E4B'}
                openTab={openTab}
                setOpenTab={setOpenTab}
              />
            </div>
            <div className="flex justify-center">
              {render(openTab)}
            </div>
            <div className="card border border-[#abb8c3] my-4 py-5 px-8">
              {location === 'uz' ?
                <h1><span className="font-bold">UNICON.UZ</span> sovg‘alar ulashadi!</h1> :
                location === "ru" ?
                  <h1><span className="font-bold">UNICON.UZ</span> дарит подарки!</h1> :
                  <h1><span className="font-bold">UNICON.UZ</span> gives gifts!</h1>
              }
              {location === 'uz' ?
                <h1><span className="font-bold">UNICON.UZ</span>dan ajoyib sovg‘a olishni
                  xohlaysizmi? Bu oson! Faqat ikkita shartni bajaring: </h1> :
                location === "ru" ?
                  <h1>Хочешь получить крутой приз от <span className="font-bold">UNICON.UZ?</span> Это просто! Выполни
                    всего 2 условия:</h1> :
                  <h1>Do you want to get a cool prize from <span className="font-bold">UNICON.UZ</span> ? It's easy!
                    Fulfill only 2 conditions:</h1>
              }
              {location === 'uz' ?
                <h1 className="ml-2">1. Saytimizda ro‘yxatdan o‘ting </h1> :
                location === 'ru' ? <h1 className="ml-2">1. Пройди регистрацию на нашем сайте</h1> :
                  <h1 className="ml-2">1. Register on our website</h1>
              }
              {location === 'uz' ?
                <h1 className="ml-2 flex gap-1 items-center">2. Ijtimoiy tarmoqdagi barcha sahifalarimizga (
                  <a className="underline"
                     href="https://www.instagram.com/unicon.uz_official/?igsh=MTk2ZmlrbzQxYzRtdw%3D%3D" target="_blank"
                  >
                    <div className="xl:w-[45%]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                      >
                        <path
                          d="M12.001 9C10.3436 9 9.00098 10.3431 9.00098 12C9.00098 13.6573 10.3441 15 12.001 15C13.6583 15 15.001 13.6569 15.001 12C15.001 10.3427 13.6579 9 12.001 9ZM12.001 7C14.7614 7 17.001 9.2371 17.001 12C17.001 14.7605 14.7639 17 12.001 17C9.24051 17 7.00098 14.7629 7.00098 12C7.00098 9.23953 9.23808 7 12.001 7ZM18.501 6.74915C18.501 7.43926 17.9402 7.99917 17.251 7.99917C16.5609 7.99917 16.001 7.4384 16.001 6.74915C16.001 6.0599 16.5617 5.5 17.251 5.5C17.9393 5.49913 18.501 6.0599 18.501 6.74915ZM12.001 4C9.5265 4 9.12318 4.00655 7.97227 4.0578C7.18815 4.09461 6.66253 4.20007 6.17416 4.38967C5.74016 4.55799 5.42709 4.75898 5.09352 5.09255C4.75867 5.4274 4.55804 5.73963 4.3904 6.17383C4.20036 6.66332 4.09493 7.18811 4.05878 7.97115C4.00703 9.0752 4.00098 9.46105 4.00098 12C4.00098 14.4745 4.00753 14.8778 4.05877 16.0286C4.0956 16.8124 4.2012 17.3388 4.39034 17.826C4.5591 18.2606 4.7605 18.5744 5.09246 18.9064C5.42863 19.2421 5.74179 19.4434 6.17187 19.6094C6.66619 19.8005 7.19148 19.9061 7.97212 19.9422C9.07618 19.9939 9.46203 20 12.001 20C14.4755 20 14.8788 19.9934 16.0296 19.9422C16.8117 19.9055 17.3385 19.7996 17.827 19.6106C18.2604 19.4423 18.5752 19.2402 18.9074 18.9085C19.2436 18.5718 19.4445 18.2594 19.6107 17.8283C19.8013 17.3358 19.9071 16.8098 19.9432 16.0289C19.9949 14.9248 20.001 14.5389 20.001 12C20.001 9.52552 19.9944 9.12221 19.9432 7.97137C19.9064 7.18906 19.8005 6.66149 19.6113 6.17318C19.4434 5.74038 19.2417 5.42635 18.9084 5.09255C18.573 4.75715 18.2616 4.55693 17.8271 4.38942C17.338 4.19954 16.8124 4.09396 16.0298 4.05781C14.9258 4.00605 14.5399 4 12.001 4ZM12.001 2C14.7176 2 15.0568 2.01 16.1235 2.06C17.1876 2.10917 17.9135 2.2775 18.551 2.525C19.2101 2.77917 19.7668 3.1225 20.3226 3.67833C20.8776 4.23417 21.221 4.7925 21.476 5.45C21.7226 6.08667 21.891 6.81333 21.941 7.8775C21.9885 8.94417 22.001 9.28333 22.001 12C22.001 14.7167 21.991 15.0558 21.941 16.1225C21.8918 17.1867 21.7226 17.9125 21.476 18.55C21.2218 19.2092 20.8776 19.7658 20.3226 20.3217C19.7668 20.8767 19.2076 21.22 18.551 21.475C17.9135 21.7217 17.1876 21.89 16.1235 21.94C15.0568 21.9875 14.7176 22 12.001 22C9.28431 22 8.94514 21.99 7.87848 21.94C6.81431 21.8908 6.08931 21.7217 5.45098 21.475C4.79264 21.2208 4.23514 20.8767 3.67931 20.3217C3.12348 19.7658 2.78098 19.2067 2.52598 18.55C2.27848 17.9125 2.11098 17.1867 2.06098 16.1225C2.01348 15.0558 2.00098 14.7167 2.00098 12C2.00098 9.28333 2.01098 8.94417 2.06098 7.8775C2.11014 6.8125 2.27848 6.0875 2.52598 5.45C2.78014 4.79167 3.12348 4.23417 3.67931 3.67833C4.23514 3.1225 4.79348 2.78 5.45098 2.525C6.08848 2.2775 6.81348 2.11 7.87848 2.06C8.94514 2.0125 9.28431 2 12.001 2Z"
                          fill="rgba(70,146,221,1)"
                        ></path>
                      </svg>
                    </div>
                  </a> ,
                  <a className="underline" href="https://www.facebook.com/uniconuz?mibextid=ZbWKwL" target="_blank"
                  >
                    <div className="xl:w-[45%]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                      >
                        <path
                          d="M12.001 2C6.47813 2 2.00098 6.47715 2.00098 12C2.00098 16.9913 5.65783 21.1283 10.4385 21.8785V14.8906H7.89941V12H10.4385V9.79688C10.4385 7.29063 11.9314 5.90625 14.2156 5.90625C15.3097 5.90625 16.4541 6.10156 16.4541 6.10156V8.5625H15.1931C13.9509 8.5625 13.5635 9.33334 13.5635 10.1242V12H16.3369L15.8936 14.8906H13.5635V21.8785C18.3441 21.1283 22.001 16.9913 22.001 12C22.001 6.47715 17.5238 2 12.001 2Z"
                          fill="rgba(70,146,221,1)"
                        ></path>
                      </svg>
                    </div>
                  </a> ,
                  <a className="underline" href="https://t.me/uniconcompany" target="_blank"
                  >
                    <div className="xl:w-[45%]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                      >
                        <path
                          d="M12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 16.4183 7.5827 20 12.001 20ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM8.89113 13.1708L6.39308 12.3911C5.85317 12.2255 5.84996 11.854 6.51397 11.5871L16.247 7.82754C16.8115 7.59644 17.1325 7.88842 16.9495 8.61641L15.2917 16.4377C15.1763 16.9941 14.8407 17.1266 14.3759 16.8698L11.825 14.9823L10.6361 16.1297C10.5139 16.2476 10.4145 16.3489 10.2273 16.3743C10.04 16.3996 9.88564 16.3442 9.77337 16.0337L8.90378 13.1628L8.89113 13.1708Z"
                          fill="rgba(70,146,221,1)"
                        ></path>
                      </svg>
                    </div>
                  </a> ,
                  <a href="https://www.youtube.com/@Uni937" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 256 180">
                      <path fill="rgba(70,146,221,1)"
                            d="M250.346 28.075A32.18 32.18 0 0 0 227.69 5.418C207.824 0 127.87 0 127.87 0S47.912.164 28.046 5.582A32.18 32.18 0 0 0 5.39 28.24c-6.009 35.298-8.34 89.084.165 122.97a32.18 32.18 0 0 0 22.656 22.657c19.866 5.418 99.822 5.418 99.822 5.418s79.955 0 99.82-5.418a32.18 32.18 0 0 0 22.657-22.657c6.338-35.348 8.291-89.1-.164-123.134"
                      />
                      <path fill="#fff" d="m102.421 128.06l66.328-38.418l-66.328-38.418z"/>
                    </svg>
                  </a>)
                  obuna bo‘ling. </h1> :
                location === 'ru' ?
                  <h1 className="ml-2 flex gap-1">
                    2. Подпишись на все наши странички в соц. сетях (
                    <a className="underline"
                       href="https://www.instagram.com/unicon.uz_official/?igsh=MTk2ZmlrbzQxYzRtdw%3D%3D" target="_blank"
                    >
                      <div className="xl:w-[45%]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                        >
                          <path
                            d="M12.001 9C10.3436 9 9.00098 10.3431 9.00098 12C9.00098 13.6573 10.3441 15 12.001 15C13.6583 15 15.001 13.6569 15.001 12C15.001 10.3427 13.6579 9 12.001 9ZM12.001 7C14.7614 7 17.001 9.2371 17.001 12C17.001 14.7605 14.7639 17 12.001 17C9.24051 17 7.00098 14.7629 7.00098 12C7.00098 9.23953 9.23808 7 12.001 7ZM18.501 6.74915C18.501 7.43926 17.9402 7.99917 17.251 7.99917C16.5609 7.99917 16.001 7.4384 16.001 6.74915C16.001 6.0599 16.5617 5.5 17.251 5.5C17.9393 5.49913 18.501 6.0599 18.501 6.74915ZM12.001 4C9.5265 4 9.12318 4.00655 7.97227 4.0578C7.18815 4.09461 6.66253 4.20007 6.17416 4.38967C5.74016 4.55799 5.42709 4.75898 5.09352 5.09255C4.75867 5.4274 4.55804 5.73963 4.3904 6.17383C4.20036 6.66332 4.09493 7.18811 4.05878 7.97115C4.00703 9.0752 4.00098 9.46105 4.00098 12C4.00098 14.4745 4.00753 14.8778 4.05877 16.0286C4.0956 16.8124 4.2012 17.3388 4.39034 17.826C4.5591 18.2606 4.7605 18.5744 5.09246 18.9064C5.42863 19.2421 5.74179 19.4434 6.17187 19.6094C6.66619 19.8005 7.19148 19.9061 7.97212 19.9422C9.07618 19.9939 9.46203 20 12.001 20C14.4755 20 14.8788 19.9934 16.0296 19.9422C16.8117 19.9055 17.3385 19.7996 17.827 19.6106C18.2604 19.4423 18.5752 19.2402 18.9074 18.9085C19.2436 18.5718 19.4445 18.2594 19.6107 17.8283C19.8013 17.3358 19.9071 16.8098 19.9432 16.0289C19.9949 14.9248 20.001 14.5389 20.001 12C20.001 9.52552 19.9944 9.12221 19.9432 7.97137C19.9064 7.18906 19.8005 6.66149 19.6113 6.17318C19.4434 5.74038 19.2417 5.42635 18.9084 5.09255C18.573 4.75715 18.2616 4.55693 17.8271 4.38942C17.338 4.19954 16.8124 4.09396 16.0298 4.05781C14.9258 4.00605 14.5399 4 12.001 4ZM12.001 2C14.7176 2 15.0568 2.01 16.1235 2.06C17.1876 2.10917 17.9135 2.2775 18.551 2.525C19.2101 2.77917 19.7668 3.1225 20.3226 3.67833C20.8776 4.23417 21.221 4.7925 21.476 5.45C21.7226 6.08667 21.891 6.81333 21.941 7.8775C21.9885 8.94417 22.001 9.28333 22.001 12C22.001 14.7167 21.991 15.0558 21.941 16.1225C21.8918 17.1867 21.7226 17.9125 21.476 18.55C21.2218 19.2092 20.8776 19.7658 20.3226 20.3217C19.7668 20.8767 19.2076 21.22 18.551 21.475C17.9135 21.7217 17.1876 21.89 16.1235 21.94C15.0568 21.9875 14.7176 22 12.001 22C9.28431 22 8.94514 21.99 7.87848 21.94C6.81431 21.8908 6.08931 21.7217 5.45098 21.475C4.79264 21.2208 4.23514 20.8767 3.67931 20.3217C3.12348 19.7658 2.78098 19.2067 2.52598 18.55C2.27848 17.9125 2.11098 17.1867 2.06098 16.1225C2.01348 15.0558 2.00098 14.7167 2.00098 12C2.00098 9.28333 2.01098 8.94417 2.06098 7.8775C2.11014 6.8125 2.27848 6.0875 2.52598 5.45C2.78014 4.79167 3.12348 4.23417 3.67931 3.67833C4.23514 3.1225 4.79348 2.78 5.45098 2.525C6.08848 2.2775 6.81348 2.11 7.87848 2.06C8.94514 2.0125 9.28431 2 12.001 2Z"
                            fill="rgba(70,146,221,1)"
                          ></path>
                        </svg>
                      </div>
                    </a> ,
                    <a className="underline" href="https://www.facebook.com/uniconuz?mibextid=ZbWKwL" target="_blank"
                    >
                      <div className="xl:w-[45%]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                        >
                          <path
                            d="M12.001 2C6.47813 2 2.00098 6.47715 2.00098 12C2.00098 16.9913 5.65783 21.1283 10.4385 21.8785V14.8906H7.89941V12H10.4385V9.79688C10.4385 7.29063 11.9314 5.90625 14.2156 5.90625C15.3097 5.90625 16.4541 6.10156 16.4541 6.10156V8.5625H15.1931C13.9509 8.5625 13.5635 9.33334 13.5635 10.1242V12H16.3369L15.8936 14.8906H13.5635V21.8785C18.3441 21.1283 22.001 16.9913 22.001 12C22.001 6.47715 17.5238 2 12.001 2Z"
                            fill="rgba(70,146,221,1)"
                          ></path>
                        </svg>
                      </div>
                    </a> ,
                    <a className="underline" href="https://t.me/uniconcompany" target="_blank"
                    >
                      <div className="xl:w-[45%]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                        >
                          <path
                            d="M12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 16.4183 7.5827 20 12.001 20ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM8.89113 13.1708L6.39308 12.3911C5.85317 12.2255 5.84996 11.854 6.51397 11.5871L16.247 7.82754C16.8115 7.59644 17.1325 7.88842 16.9495 8.61641L15.2917 16.4377C15.1763 16.9941 14.8407 17.1266 14.3759 16.8698L11.825 14.9823L10.6361 16.1297C10.5139 16.2476 10.4145 16.3489 10.2273 16.3743C10.04 16.3996 9.88564 16.3442 9.77337 16.0337L8.90378 13.1628L8.89113 13.1708Z"
                            fill="rgba(70,146,221,1)"
                          ></path>
                        </svg>
                      </div>
                    </a> ,
                    <a href="https://www.youtube.com/@Uni937" target="_blank">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 256 180">
                        <path fill="rgba(70,146,221,1)"
                              d="M250.346 28.075A32.18 32.18 0 0 0 227.69 5.418C207.824 0 127.87 0 127.87 0S47.912.164 28.046 5.582A32.18 32.18 0 0 0 5.39 28.24c-6.009 35.298-8.34 89.084.165 122.97a32.18 32.18 0 0 0 22.656 22.657c19.866 5.418 99.822 5.418 99.822 5.418s79.955 0 99.82-5.418a32.18 32.18 0 0 0 22.657-22.657c6.338-35.348 8.291-89.1-.164-123.134"
                        />
                        <path fill="#fff" d="m102.421 128.06l66.328-38.418l-66.328-38.418z"/>
                      </svg>
                    </a>)
                  </h1> :
                  <h1 className="ml-2 flex gap-1">
                    2. Subscribe to all our social media pages. social networks (
                    <a className="underline"
                       href="https://www.instagram.com/unicon.uz_official/?igsh=MTk2ZmlrbzQxYzRtdw%3D%3D" target="_blank"
                    >
                      <div className="xl:w-[45%]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                        >
                          <path
                            d="M12.001 9C10.3436 9 9.00098 10.3431 9.00098 12C9.00098 13.6573 10.3441 15 12.001 15C13.6583 15 15.001 13.6569 15.001 12C15.001 10.3427 13.6579 9 12.001 9ZM12.001 7C14.7614 7 17.001 9.2371 17.001 12C17.001 14.7605 14.7639 17 12.001 17C9.24051 17 7.00098 14.7629 7.00098 12C7.00098 9.23953 9.23808 7 12.001 7ZM18.501 6.74915C18.501 7.43926 17.9402 7.99917 17.251 7.99917C16.5609 7.99917 16.001 7.4384 16.001 6.74915C16.001 6.0599 16.5617 5.5 17.251 5.5C17.9393 5.49913 18.501 6.0599 18.501 6.74915ZM12.001 4C9.5265 4 9.12318 4.00655 7.97227 4.0578C7.18815 4.09461 6.66253 4.20007 6.17416 4.38967C5.74016 4.55799 5.42709 4.75898 5.09352 5.09255C4.75867 5.4274 4.55804 5.73963 4.3904 6.17383C4.20036 6.66332 4.09493 7.18811 4.05878 7.97115C4.00703 9.0752 4.00098 9.46105 4.00098 12C4.00098 14.4745 4.00753 14.8778 4.05877 16.0286C4.0956 16.8124 4.2012 17.3388 4.39034 17.826C4.5591 18.2606 4.7605 18.5744 5.09246 18.9064C5.42863 19.2421 5.74179 19.4434 6.17187 19.6094C6.66619 19.8005 7.19148 19.9061 7.97212 19.9422C9.07618 19.9939 9.46203 20 12.001 20C14.4755 20 14.8788 19.9934 16.0296 19.9422C16.8117 19.9055 17.3385 19.7996 17.827 19.6106C18.2604 19.4423 18.5752 19.2402 18.9074 18.9085C19.2436 18.5718 19.4445 18.2594 19.6107 17.8283C19.8013 17.3358 19.9071 16.8098 19.9432 16.0289C19.9949 14.9248 20.001 14.5389 20.001 12C20.001 9.52552 19.9944 9.12221 19.9432 7.97137C19.9064 7.18906 19.8005 6.66149 19.6113 6.17318C19.4434 5.74038 19.2417 5.42635 18.9084 5.09255C18.573 4.75715 18.2616 4.55693 17.8271 4.38942C17.338 4.19954 16.8124 4.09396 16.0298 4.05781C14.9258 4.00605 14.5399 4 12.001 4ZM12.001 2C14.7176 2 15.0568 2.01 16.1235 2.06C17.1876 2.10917 17.9135 2.2775 18.551 2.525C19.2101 2.77917 19.7668 3.1225 20.3226 3.67833C20.8776 4.23417 21.221 4.7925 21.476 5.45C21.7226 6.08667 21.891 6.81333 21.941 7.8775C21.9885 8.94417 22.001 9.28333 22.001 12C22.001 14.7167 21.991 15.0558 21.941 16.1225C21.8918 17.1867 21.7226 17.9125 21.476 18.55C21.2218 19.2092 20.8776 19.7658 20.3226 20.3217C19.7668 20.8767 19.2076 21.22 18.551 21.475C17.9135 21.7217 17.1876 21.89 16.1235 21.94C15.0568 21.9875 14.7176 22 12.001 22C9.28431 22 8.94514 21.99 7.87848 21.94C6.81431 21.8908 6.08931 21.7217 5.45098 21.475C4.79264 21.2208 4.23514 20.8767 3.67931 20.3217C3.12348 19.7658 2.78098 19.2067 2.52598 18.55C2.27848 17.9125 2.11098 17.1867 2.06098 16.1225C2.01348 15.0558 2.00098 14.7167 2.00098 12C2.00098 9.28333 2.01098 8.94417 2.06098 7.8775C2.11014 6.8125 2.27848 6.0875 2.52598 5.45C2.78014 4.79167 3.12348 4.23417 3.67931 3.67833C4.23514 3.1225 4.79348 2.78 5.45098 2.525C6.08848 2.2775 6.81348 2.11 7.87848 2.06C8.94514 2.0125 9.28431 2 12.001 2Z"
                            fill="rgba(70,146,221,1)"
                          ></path>
                        </svg>
                      </div>
                    </a> ,
                    <a className="underline" href="https://www.facebook.com/uniconuz?mibextid=ZbWKwL" target="_blank"
                    >
                      <div className="xl:w-[45%]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                        >
                          <path
                            d="M12.001 2C6.47813 2 2.00098 6.47715 2.00098 12C2.00098 16.9913 5.65783 21.1283 10.4385 21.8785V14.8906H7.89941V12H10.4385V9.79688C10.4385 7.29063 11.9314 5.90625 14.2156 5.90625C15.3097 5.90625 16.4541 6.10156 16.4541 6.10156V8.5625H15.1931C13.9509 8.5625 13.5635 9.33334 13.5635 10.1242V12H16.3369L15.8936 14.8906H13.5635V21.8785C18.3441 21.1283 22.001 16.9913 22.001 12C22.001 6.47715 17.5238 2 12.001 2Z"
                            fill="rgba(70,146,221,1)"
                          ></path>
                        </svg>
                      </div>
                    </a> ,
                    <a className="underline" href="https://t.me/uniconcompany" target="_blank"
                    >
                      <div className="xl:w-[45%]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                        >
                          <path
                            d="M12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 16.4183 7.5827 20 12.001 20ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM8.89113 13.1708L6.39308 12.3911C5.85317 12.2255 5.84996 11.854 6.51397 11.5871L16.247 7.82754C16.8115 7.59644 17.1325 7.88842 16.9495 8.61641L15.2917 16.4377C15.1763 16.9941 14.8407 17.1266 14.3759 16.8698L11.825 14.9823L10.6361 16.1297C10.5139 16.2476 10.4145 16.3489 10.2273 16.3743C10.04 16.3996 9.88564 16.3442 9.77337 16.0337L8.90378 13.1628L8.89113 13.1708Z"
                            fill="rgba(70,146,221,1)"
                          ></path>
                        </svg>
                      </div>
                    </a> ,
                    <a href="https://www.youtube.com/@Uni937" target="_blank">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 256 180">
                        <path fill="rgba(70,146,221,1)"
                              d="M250.346 28.075A32.18 32.18 0 0 0 227.69 5.418C207.824 0 127.87 0 127.87 0S47.912.164 28.046 5.582A32.18 32.18 0 0 0 5.39 28.24c-6.009 35.298-8.34 89.084.165 122.97a32.18 32.18 0 0 0 22.656 22.657c19.866 5.418 99.822 5.418 99.822 5.418s79.955 0 99.82-5.418a32.18 32.18 0 0 0 22.657-22.657c6.338-35.348 8.291-89.1-.164-123.134"
                        />
                        <path fill="#fff" d="m102.421 128.06l66.328-38.418l-66.328-38.418z"/>
                      </svg>
                    </a>)
                  </h1>
              }
              {location === 'uz' ?
                <h1>Shuni o‘zi kifoya! Sizni <span className="font-bold">17-20 sentabr</span> kunlari <span
                  className="font-bold"
                >ICT Week</span>'da sovg‘alar bilan kutamiz!
                </h1> :
                location === 'ru' ?
                  <h1>И всё! Ждем вас с подарками на <span className="font-bold">ICT Week 17-20 сентября!</span></h1> :
                  <h1>And that's it! We are waiting for you with gifts for <span className="font-bold">ICT Week on September 17-20!</span>
                  </h1>
              }

              {location === 'uz' ?
                <h1><span className="font-bold">Manzil</span>: "CAEx" (Central Asian Expo Uzbekistan), Milliy bog'
                  ko'chasi, 1, Toshkent, O'zbekiston</h1> :
                location === 'ru' ?
                  <h1><span className="font-bold">Адрес</span>: «CAEx» (Central Asian Expo Uzbekistan), ул. Миллий бог,
                    1, Ташкент, Узбекистан</h1> :
                  <h1><span className="font-bold">Аddress</span>: "CAEx" (Central Asian Expo Uzbekistan), Milliy bog'
                    street, 1, Tashkent, Uzbekistan</h1>
              }
              <div className="w-full h-full my-8">
                <img src={IMAGE} alt="week" className="w-full h-full object-cover"/>
              </div>
            </div>
          </div>
        </div>
        {modal && <SuccessModal
          text={location === 'uz' ? "Muvofaqqiyatli ro'yxatdan o'tdingiz!" : location === 'ru' ? "Вы прошли регистрацию успешно!" : 'You registered successfully!'}
          onclose={() => setModal(false)}
        />}
        {modalPolicy && <PolicyModal onclose={() => setModalPolicy(false)}/>}
      </div>
    </>
  );
};

export default Register;